
import { defineComponent, PropType } from "vue";
import { ISiteSearchResultItem } from "../../clients/search/src/models";

export default defineComponent({
  props: {
    result: {
      type: Object as PropType<ISiteSearchResultItem>,
      required: true
    }
  },
  computed: {
    resultUrl() {
      const urlParts: string[] = [window.location.origin, this.result?.url];

      return urlParts
        .map((url) => (url ? url.replace(/^\/+|\/+$/g, "") : ""))
        .join("/");
    }
  }
});
